import { Extensions } from "../models/extentions.model";


export const MEDIA_EXTENTIONS: Extensions[] = [
    {
        id: 'png',
        name: 'png',
    },
    {
        id: 'jpeg',
        name: 'jpeg'
    },
    {
        id: 'jpg',
        name: 'jpg'
    }
];

export const TEXT_EXTENTIONS: Extensions[] = [
    {
        id: 'xml',
        name: 'xml'
    },
    {
        id: 'xlsx',
        name: 'xlsx'
    },

    {
        id: 'docx',
        name: 'docx'
    }
];